import { gql } from '@apollo/client';

import { graphql } from '../gql';

export const GET_EVENTS = graphql(`
  query Events {
    gec_events {
      id
      uuid
      title
      created_at
      updated_at
      start_date_time
      start_date_time_utc
      event_type_id
      end_date_time
      end_date_time_utc
      event_format {
        id
        name
      }
      audience_in_events {
        audience {
          id
          name
        }
      }
      event_details
      event_exceptions {
        id
        exception_date
        exception_date_utc
      }
      event_type {
        id
        event_type
        hosting_type
        color
      }
      external_office
      firm_initiatives_in_event {
        firm_initiatives {
          id
          name
        }
      }
      industries_in_event {
        industries {
          id
          name
        }
      }
      departments_in_event {
        departments {
          id
          name
        }
      }
      is_all_day
      is_cle
      is_client_event_or_celebration
      is_invite_only
      is_recurring
      offices_in_events {
        office {
          id
          office_code
          name
          address
        }
      }
      outside_speakers {
        id
        name
        title
        organization
      }
      practice_groups_in_event {
        practice_groups {
          id
          name
        }
      }
      recurrence_pattern
      sponsoring_orgnization
      hosting_group_other
      hosting_type
      time_zone
      event_type_other
      sponsoring_attorney_in_events {
        user_id
        user {
          NamePreferredDisplay
          Email
          ActiveDirectoryLogin
          BusinessPrimaryOfficePhoneNumberFull
          TitleFullyQualified
          BusinessPrimaryOfficeAddress1
          BusinessPrimaryOffice
          PrimaryPracticeGroup {
            PracticeGroupName
            SubSubPracticeGroupName
          }
        }
      }
      created_by
      created_by_user {
        NamePreferredDisplay
        Email
        ActiveDirectoryLogin
        BusinessPrimaryOfficePhoneNumberFull
        TitleFullyQualified
        BusinessPrimaryOfficeAddress1
        BusinessPrimaryOffice
        PrimaryPracticeGroup {
          PracticeGroupName
          SubSubPracticeGroupName
        }
      }
      updated_by
      duration
      contact_in_events {
        user {
          NamePreferredDisplay
          Email
          ActiveDirectoryLogin
          BusinessPrimaryOfficePhoneNumberFull
          TitleFullyQualified
          BusinessPrimaryOfficeAddress1
          BusinessPrimaryOffice
          PrimaryPracticeGroup {
            PracticeGroupName
            SubSubPracticeGroupName
          }
        }
        user_id
      }
      speaker_in_events {
        user_id
        user {
          NamePreferredDisplay
          Email
          ActiveDirectoryLogin
          BusinessPrimaryOfficePhoneNumberFull
          TitleFullyQualified
          BusinessPrimaryOfficeAddress1
          BusinessPrimaryOffice
          PrimaryPracticeGroup {
            PracticeGroupName
            SubSubPracticeGroupName
          }
        }
      }
    }
  }
`);

export const GET_FILTERED_EVENTS = graphql(`
  query EventsFilter($filters: gec_events_bool_exp!, $limit: Int, $offset: Int) {
    gec_events(where: $filters, limit: $limit, offset: $offset, order_by: { start_date_time_utc: asc }) {
      id
      uuid
      title
      created_at
      updated_at
      start_date_time
      start_date_time_utc
      event_type_id
      event_format {
        id
        name
      }
      end_date_time
      end_date_time_utc
      audience_in_events {
        audience {
          id
          name
        }
      }
      event_details
      event_exceptions {
        id
        exception_date
        exception_date_utc
      }
      event_type {
        id
        event_type
        hosting_type
        color
      }
      external_office
      firm_initiatives_in_event {
        firm_initiatives {
          id
          name
        }
      }
      industries_in_event {
        industries {
          id
          name
        }
      }
      departments_in_event {
        departments {
          id
          name
        }
      }
      is_all_day
      is_cle
      is_client_event_or_celebration
      is_invite_only
      is_recurring
      offices_in_events {
        office {
          id
          office_code
          name
          address
        }
      }
      office_visibility_in_events {
        office {
          id
          office_code
          name
          address
        }
      }
      outside_speakers {
        id
        name
        title
        organization
      }
      practice_groups_in_event {
        practice_groups {
          id
          name
        }
      }
      recurrence_pattern
      sponsoring_orgnization
      hosting_group_other
      hosting_type
      time_zone
      event_type_other
      sponsoring_attorney_in_events {
        user_id
        user {
          NamePreferredDisplay
          Email
          ActiveDirectoryLogin
          BusinessPrimaryOfficePhoneNumberFull
          TitleFullyQualified
          BusinessPrimaryOfficeAddress1
          BusinessPrimaryOffice
          PrimaryPracticeGroup {
            PracticeGroupName
            SubSubPracticeGroupName
          }
        }
      }
      created_by
      created_by_user {
        ActiveDirectoryLogin
        NamePreferredDisplay
        Email
        BusinessPrimaryOfficePhoneNumberFull
        TitleFullyQualified
        PrimaryPracticeGroup {
          PracticeGroupName
          SubSubPracticeGroupName
        }
        PrimaryOffice {
          OfficeAddress1
          OfficeCity
          OfficeState
          OfficeZipCode
          OfficeCountryName
        }
      }
      updated_at
      updated_by
      updated_by_user {
        ActiveDirectoryLogin
        NamePreferredDisplay
        Email
        BusinessPrimaryOfficePhoneNumberFull
        TitleFullyQualified
        PrimaryPracticeGroup {
          PracticeGroupName
          SubSubPracticeGroupName
        }
        PrimaryOffice {
          OfficeAddress1
          OfficeCity
          OfficeState
          OfficeZipCode
          OfficeCountryName
        }
      }
      duration
      contact_in_events {
        user {
          NamePreferredDisplay
          Email
          ActiveDirectoryLogin
          BusinessPrimaryOfficePhoneNumberFull
          TitleFullyQualified
          BusinessPrimaryOfficeAddress1
          BusinessPrimaryOffice
          PrimaryPracticeGroup {
            PracticeGroupName
            SubSubPracticeGroupName
          }
        }
        user_id
      }
      speaker_in_events {
        user_id
        user {
          NamePreferredDisplay
          Email
          ActiveDirectoryLogin
          BusinessPrimaryOfficePhoneNumberFull
          TitleFullyQualified
          BusinessPrimaryOfficeAddress1
          BusinessPrimaryOffice
          PrimaryPracticeGroup {
            PracticeGroupName
            SubSubPracticeGroupName
          }
        }
      }
    }
  }
`);

export const GET_AUDIENCE_NAMES = graphql(`
  query Audience {
    gec_audience {
      id
      name
    }
  }
`);

export const GET_PRACTICES = graphql(`
  query Practices {
    gec_practice_groups_rollup {
      id
      name
    }
  }
`);

export const GET_DEPARTMENTS = graphql(`
  query Departments {
    gec_departments {
      id
      name
    }
  }
`);

export const GET_OPTION_VALUES = graphql(`
  query OptionValues {
    gec_audience {
      id
      name
    }
    gec_event_type {
      id
      event_type
      hosting_type
      color
    }
    gec_firm_initiatives {
      id
      name
    }
    gec_industries {
      id
      name
    }
    gec_departments {
      id
      name
    }
    mlfsl_office(
      where: {
        OfficeActiveFlag: { _eq: "A" }
        DimOfficeNowKey: { _nin: [9, 15, 16, 33, 45, 48, 49, 51, 54, 56, 57, 58, 59, 60, 61, 63, 65, 76] }
      }
    ) {
      id: DimOfficeNowKey
      office: OfficeNameDisplay
      office_address: OfficeAddress1
    }
    gec_practice_groups_rollup {
      id
      name
    }
  }
`);

export const GET_OFFICES = graphql(`
  query Offices {
    gec_offices {
      id
      office_code
      name
      address
    }
  }
`);

export const GET_EVENT_TYPES = graphql(`
  query EventTypes {
    gec_event_type {
      id
      event_type
      hosting_type
      color
    }
  }
`);

export const GET_EVENT_FORMAT = graphql(`
  query EventFormat {
    gec_event_format {
      id
      name
    }
  }
`);

export const SEARCH_USERS = graphql(`
  query SearchUser($searchString: String!, $limit: Int = 5) {
    mlfsl_personnel(
      where: { NamePreferredDisplay: { _like: $searchString }, ActiveDirectoryDisabledIndicator: { _eq: "N" } }
      limit: $limit
    ) {
      NamePreferredDisplay
      Email
      ActiveDirectoryLogin
      BusinessPrimaryOfficePhoneNumberFull
      TitleFullyQualified
      BusinessPrimaryOfficeAddress1
      BusinessPrimaryOffice
      PrimaryPracticeGroup {
        PracticeGroupName
        SubSubPracticeGroupName
      }
    }
  }
`);

export const QRY_GET_USER = gql`
  query GetUser {
    me {
      displayName
      givenName
      surname
      jobTitle
      businessPhones
      mobilePhone
      officeLocation
      userPrincipalName
      images {
        large
        medium
        small
      }
      id
      mail
      preferredLanguage
    }
  }
`;

// MUTATIONS //

export const INSERT_EVENT = graphql(`
  mutation InsertEvent($event: gec_events_insert_input!) {
    insert_gec_events_one(object: $event) {
      id
    }
  }
`);

export const DELETE_EVENT = graphql(`
  mutation DeleteEvent($id: Int!) {
    delete_gec_events_by_pk(id: $id) {
      id
    }
  }
`);

// Update Event Mutation with related inserts and deletes for office_in_events
export const UPDATE_EVENT = graphql(`
  mutation UpdateEvent(
    $id: Int!
    $event: gec_events_set_input!
    $practice_groups: [gec_practice_groups_in_event_insert_input!]!
    $firm_initiatives: [gec_firm_initiatives_in_event_insert_input!]!
    $industries: [gec_industries_in_event_insert_input!]!
    $departments: [gec_departments_in_event_insert_input!]!
    $audience: [gec_audience_in_event_insert_input!]!
    $outside_speakers: [gec_outside_speakers_insert_input!]!
    $event_contacts: [gec_contact_in_event_insert_input!] = {}
    $ml_speakers: [gec_speaker_in_event_insert_input!] = {}
    $offices_in_events: [gec_offices_in_event_insert_input!] = {}
    $sponsoring_attorneys: [gec_sponsoring_attorney_in_event_insert_input!] = {}
    $calendar_visibility: [gec_office_visibility_in_event_insert_input!] = {}
  ) {
    update_gec_events_by_pk(pk_columns: { id: $id }, _set: $event) {
      id
    }
    delete_gec_audience_in_event(where: { event_id: { _eq: $id } }) {
      affected_rows
    }
    delete_gec_practice_groups_in_event(where: { event_id: { _eq: $id } }) {
      affected_rows
    }
    delete_gec_firm_initiatives_in_event(where: { event_id: { _eq: $id } }) {
      affected_rows
    }
    delete_gec_industries_in_event(where: { event_id: { _eq: $id } }) {
      affected_rows
    }
    delete_gec_departments_in_event(where: { event_id: { _eq: $id } }) {
      affected_rows
    }
    delete_gec_outside_speakers(where: { event_id: { _eq: $id } }) {
      affected_rows
    }
    delete_gec_contact_in_event(where: { event_id: { _eq: $id } }) {
      affected_rows
    }
    delete_gec_speaker_in_event(where: { event_id: { _eq: $id } }) {
      affected_rows
    }
    delete_gec_sponsoring_attorney_in_event(where: { event_id: { _eq: $id } }) {
      affected_rows
    }
    delete_gec_offices_in_event(where: { event_id: { _eq: $id } }) {
      affected_rows
    }
    delete_gec_office_visibility_in_event(where: { event_id: { _eq: $id } }) {
      affected_rows
    }
    insert_gec_office_visibility_in_event(objects: $calendar_visibility) {
      affected_rows
    }
    insert_gec_offices_in_event(objects: $offices_in_events) {
      affected_rows
    }
    insert_gec_audience_in_event(objects: $audience) {
      affected_rows
    }
    insert_gec_practice_groups_in_event(objects: $practice_groups) {
      affected_rows
    }
    insert_gec_firm_initiatives_in_event(objects: $firm_initiatives) {
      affected_rows
    }
    insert_gec_industries_in_event(objects: $industries) {
      affected_rows
    }
    insert_gec_departments_in_event(objects: $departments) {
      affected_rows
    }
    insert_gec_outside_speakers(objects: $outside_speakers) {
      affected_rows
    }
    insert_gec_contact_in_event(objects: $event_contacts) {
      affected_rows
    }
    insert_gec_speaker_in_event(objects: $ml_speakers) {
      affected_rows
    }
    insert_gec_sponsoring_attorney_in_event(objects: $sponsoring_attorneys) {
      affected_rows
    }
  }
`);

export const INSERT_EVENT_EXCEPTION = graphql(`
  mutation InsertEventException($event_exception: gec_event_exception_insert_input!) {
    insert_gec_event_exception_one(object: $event_exception) {
      id
    }
  }
`);

export const MIGRATE_EVENT_DATETIME = graphql(`
  mutation MigrateEventDateTime($events: [gec_events_updates!]!, $event_exceptions: [gec_event_exception_updates!]!) {
    update_gec_events_many(updates: $events) {
      affected_rows
      returning {
        id
        start_date_time
        end_date_time
        recurrence_pattern
      }
    }
    update_gec_event_exception_many(updates: $event_exceptions) {
      affected_rows
      returning {
        id
        exception_date
        event_id
      }
    }
  }
`);
